import React, { useState } from "react";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";

const CompanySlotDays = ({ option, days, setDays, handleSubmit, type }) => {
  const [daysList, setDaysList] = useState(["T", "W", "Th", "F", "S", "SU"]);
  const [selectedDay, setSelectedDay] = useState(1);
  const [showSchedule, setShowSchedule] = useState(false);
  const [realDay, setRealDay] = useState("Monday");
  const [schedule, setSchedule] = useState([]);
  const [index_, setIndex_] = useState(0);

  const handleDayClick = (day, ind) => {
    setIndex_(ind);
    setSelectedDay(day);
  };

  const getDayAbbreviation = (day) => {
    switch (day) {
      case "Monday":
        return "M";
      case "Tuesday":
        return "T";
      case "Wednesday":
        return "W";
      case "Thursday":
        return "Th";
      case "Friday":
        return "F";
      case "Saturday":
        return "S";
      case "Sunday":
        return "SU";
      default:
        return day;
    }
  };

  // console.log('daysList', daysList)
  const handleToggle = (ind, type, value) => {
    let temp = [...days];
    if (type == "toggle") {
      temp[ind] = {
        ...temp[ind],
        [type]: value,
        start_time: "",
        end_time: "",
      };
    } else {
      temp[ind] = {
        ...temp[ind],
        [type]: value,
      };
    }
    setDays(temp);
  };

  // console.log('scheduleDays', schedule)
  //   console.log(selectedDay, "selectedDay");
  // console.log("days?.[index_]", days?.[index_]);

  return (
    <div className="dashRightView">
      {option?.value && (
        <div className="slot-container d-flex">
          {/* Days Button */}
          <div className="days-wrapper d-flex ac-jb">
            {days?.map((day, ind) => {
              return (
                <button
                  key={ind}
                  className={`f2 fs-sm-10 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 day-btn ${
                    selectedDay == day?.type ? "active" : ""
                  }`}
                  onClick={() => handleDayClick(day?.type, ind)}
                >
                  {day?.day}
                </button>
              );
            })}
          </div>

          {/* Schedule Box */}
          {days?.length > 0 && (
            <div className="Oversall-box d-flex ac-jb">
              <div className="d-flex ac-js gap-3 my-4">
                <h3 className="f3 fs-sm-19 fs-md-18 fs-lg-18 fs-xl-22 fs-xxl-27">
                  {days?.[index_]?.day} Schedule
                </h3>
                <div
                  className="gap-3 d-flex toggle-btn"
                  onClick={() => {
                    if (type !== "slot") {
                      handleToggle(
                        index_,
                        "toggle",
                        days?.[index_]?.toggle ? false : true
                      );
                    }
                  }}
                  style={{ width: 89, height: 50, overflow: "hidden" }}
                >
                  {days?.[index_]?.toggle ? (
                    <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                  ) : (
                    <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                  )}
                </div>
                {/* <div
                className="gap-3 d-flex toggle-btn"
                onClick={() => {
                 
                }}
              >
                {days?.[index_]?.toggle ? (
                  <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                ) : (
                  <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                )}
              </div> */}
              </div>

              {days?.[index_]?.toggle && (
                <div className="schedule-box ">
                  <div className="time-inputs">
                    <div>
                      <label className="f2 fs-sm-7 fs-md-9 fs-lg-11 fs-xl-13 fs-xxl-15">
                        Start Time (mins)
                      </label>
                      <input
                        type="time"
                        value={days?.[index_]?.start_time}
                        onChange={(e) => {
                          if (type !== "slot") {
                            handleToggle(index_, "start_time", e.target.value);
                          }
                        }}
                      />
                    </div>
                    <div>
                      <label className="f2 fs-sm-7 fs-md-9 fs-lg-11 fs-xl-13 fs-xxl-15">
                        End Time (mins)
                      </label>
                      <input
                        type="time"
                        value={days?.[index_]?.end_time}
                        onChange={(e) => {
                          if (type !== "slot") {
                            handleToggle(index_, "end_time", e.target.value);
                          }
                        }}
                      />
                    </div>
                  </div>

                  {type !== "slot" && (
                    <div className="d-flex as-je mt-5">
                      <button
                        className="submit-btn "
                        onClick={() => handleSubmit(index_)}
                      >
                        Submit
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CompanySlotDays;
